import React from "react";
import moment from "moment";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

/*
Pieces shared by the two Note tab sections (TicketNotesSection and
CommercialNotesSection). Modals reuse the tn-modal-* shell from
ConfirmModal.js rather than react-modal, so they pick up this screen's theme.
*/

export const newestFirst = function (items) {
  return (items || []).slice().sort(function (a, b) {
    return moment(b.created) - moment(a.created);
  });
};

// Quill leaves "<p><br></p>" behind once the editor is cleared.
export const isBlank = function (html) {
  return !String(html || "")
    .replace(/<[^>]*>/g, "")
    .trim();
};

export const formatWhen = function (value) {
  const when = value ? moment(value) : null;
  return when && when.isValid() ? when.format("DD MMM YYYY · HH:mm") : "—";
};

export const NoteModal = function (props) {
  const { title, busy, error, saveDisabled, onSave, onClose, children } = props;
  return (
    <div className="tn-modal-overlay" onClick={busy ? undefined : onClose}>
      <div
        className="tn-modal tn-modal-wide"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={function (e) {
          e.stopPropagation();
        }}
      >
        <p className="tn-modal-title">{title}</p>
        {children}
        {error ? <p className="tn-note-error">{error}</p> : null}
        <div className="tn-modal-actions">
          <button type="button" className="tn-btn tn-btn-ghost tn-btn-sm" onClick={onClose} disabled={busy}>
            {onSave ? "Cancel" : "Close"}
          </button>
          {onSave ? (
            <button
              type="button"
              className="tn-btn tn-btn-primary tn-btn-sm"
              onClick={onSave}
              disabled={busy || saveDisabled}
            >
              {busy ? "Saving…" : "Save"}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export const NoteEditor = function (props) {
  return (
    <div className="tn-note-editor">
      <ReactQuill value={props.value || ""} onChange={props.onChange} />
    </div>
  );
};
